export function targetScoreButtonText(targetRange, measure, showNonPercentageMeasure = true) {
  const rangeLabel = targetRange[0] === targetRange[1] ? targetRange[0] : `${targetRange[0]}-${targetRange[1]}`;
  let updatedMeasure = showNonPercentageMeasure || measure === "%" ? measure : "";
  return `${rangeLabel}${updatedMeasure}`;
}
